module.exports = __webpack_public_path__ + "static/media/Take the tour Well Well Well.f2d0b767.mp4";